module.exports = __webpack_public_path__ + "glyphicons-halflings-regular-22037a34.68ed1dac06bf0409c18a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bootstrap/glyphicons-halflings-regular-22037a34.woff
// module id = 452
// module chunks = 2